import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { SelectChangeEvent } from '@mui/material';
export interface ItemSet {
  value: string;
  label: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const menuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const getStyles = (name: string, personName: string[], theme: Theme) => ({
  fontWeight:
    personName.indexOf(name) === -1
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
});

export default function MultipleSelect(props: {
  names: ItemSet[];
  placeholder: string;
  onChange: (values: string[], index: number) => void;
  index: number;
  disabled: boolean;
  onBlur?: (e: React.FocusEvent<HTMLLabelElement>) => void;
}) {
  const { names, placeholder, index, onChange, disabled, onBlur } = props;

  const theme = useTheme();
  const [selected, setSelected] = React.useState<string[]>([]);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    onChange(typeof value === 'string' ? value.split(',') : value, index);
    setSelected(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel onBlur={onBlur} id="demo-multiple-name-label">
          {placeholder}
        </InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          value={selected}
          onChange={handleChange}
          input={<OutlinedInput label="Name" />}
          MenuProps={menuProps}
          disabled={disabled}
        >
          {names.map((item) => (
            <MenuItem
              key={item.value}
              value={JSON.stringify({
                value: item.value,
                label: item.label,
              })}
              style={getStyles(item.label, selected, theme)}
            >
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
